import { render } from "./NodeShareModal.vue?vue&type=template&id=b82f54d4&scoped=true&ts=true"
import script from "./NodeShareModal.vue?vue&type=script&lang=ts"
export * from "./NodeShareModal.vue?vue&type=script&lang=ts"

import "./NodeShareModal.vue?vue&type=style&index=0&id=b82f54d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b82f54d4"]])

export default __exports__